import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CouponInfoSliceInitialState } from './couponInfoTypes';
import {
  clearCouponInfo,
  getCouponById,
  getCouponByPromotionCode
} from './couponInfoActions';
import {
  isFulfilledAction,
  isPendingAction,
  isRejectedAction,
} from '../../sliceHelpers';

const initialState: CouponInfoSliceInitialState = {
  couponInfo: null,
  isLoading: false,
};

export const couponSlice = createSlice({
  name: '@@couponInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCouponById.fulfilled, (state, action) => {
      state.couponInfo = action.payload;
    });
    builder.addCase(getCouponByPromotionCode.fulfilled, (state, action) => {
      state.couponInfo = action.payload;
    });
    builder.addCase(clearCouponInfo, (state) => {
      state.couponInfo = null;
    });
    builder.addMatcher(isPendingAction, (state) => {
      state.isLoading = true;
    });
    builder.addMatcher(isFulfilledAction, (state) => {
      state.isLoading = false;
    });
    builder.addMatcher(isRejectedAction, (state) => {
      state.isLoading = false;
    });
  },
});

export const couponInfoSelector = createSelector(
  [(state: RootState) => state.coupon.couponInfo],
  (info) => info
);

export const isLoadingCouponSelector = createSelector(
  [(state: RootState) => state.coupon.isLoading],
  (info) => info
);